import { render, staticRenderFns } from "./PanelBlueLabelPlayerInsurance.vue?vue&type=template&id=81cb9c3e&scoped=true&"
import script from "./PanelBlueLabelPlayerInsurance.vue?vue&type=script&lang=js&"
export * from "./PanelBlueLabelPlayerInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PanelBlueLabelPlayerInsurance.vue?vue&type=style&index=0&id=81cb9c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cb9c3e",
  null
  
)

export default component.exports